<template>
  <div
    class="simple-modal"
    aria-hidden="true"
    :id="id"
  >
    <div class="modal-overlay" tabindex="-1">
      <div
        class="modal-container"
        role="dialog"
        aria-modal="true"
      >
        <div class="text-right">
          <button class="modal-close" @click="close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-content" ref="modalContent">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
  },
  methods: {
    show(option = {
      resetScroll: true,
    }) {
      this.$modal.show(this.id)

      if (option.resetScroll) {
        // モーダル開いた時にモーダル内スクロール位置をリセットする
        this.$refs.modalContent.scrollTo(0, 0)
      }
    },
    close() {
      this.$modal.close(this.id)
    },
  },
}
</script>
